import { defineMessages } from "react-intl";
import { AccountVerificationStatus } from "../../contract/pam.js";
const localizedInitiateSecurityKYC = defineMessages({
  [AccountVerificationStatus.InitLoginKyc]: {
    id: "accountVerificationStatusInitLoginKyc",
    defaultMessage: "Reverify Login"
  },
  [AccountVerificationStatus.InitWithdrawalKyc]: {
    id: "accountVerificationStatusInitWithdrawalKyc",
    defaultMessage: "Reverify Withdrawal"
  }
});
export {
  localizedInitiateSecurityKYC
};
//# sourceMappingURL=initiateSecurityKYC.js.map
